import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import TitleContentColumns from './TitleContentColumns'
import AssociatedNgssStandardsTable from './AssociatedNgssStandardsTable'
import '../assets/css/components/module-overview.css'

const ModuleOverview = ({ formattedPes, module }) => {
  const buildTopicSubheader = ()=> {
    if(!_.isEmpty(module.ngss_topic_arrangements)) {
      return(
        <div className='topic-subheader'>
          {_.map(module.ngss_topic_arrangements, (title,index)=>
            <h2 key={`${title}-${index}`} >{index === 0 ? 'Topic: '+title : title}</h2>
          )}
          <br/><br/>
        </div>
      )
    }
  }

  return(
    <div className='module-subpage module-overview'>
      <h1><span className="semi-bold">Overview</span></h1>

      {buildTopicSubheader()}

      <TitleContentColumns title='Storyline >'>
        <p className='storyline-text'>{module.storyline_description}</p>
      </TitleContentColumns>

      {module.sandbox_description &&
        <TitleContentColumns title='Sandbox >'>
          <p className='sandbox-text'>{module.sandbox_description}</p>
        </TitleContentColumns>
      }

      <h3><span className="semi-bold">Module Standards</span></h3>
      <AssociatedNgssStandardsTable pes={formattedPes} dcis={module.ngss_dcis} seps={module.ngss_seps} cccs={module.ngss_cccs}/>
    </div>
  )
}

ModuleOverview.propTypes = {
  module: PropTypes.object.isRequired,
  formattedPes: PropTypes.object.isRequired
}

export default ModuleOverview
